import React from 'react';
import { Input, Popover } from 'antd';
import { string, bool, func, shape, number } from 'prop-types';
import Button from '../../components/Button';
import NoImage from '../../assets/images/no-image-320x200.jpg';
import { constants, utils } from '../../devUtils';
import { ALERT_LYRA_VOUCHER_VALUES } from './constants';
import endPoints from '../../config/endPoints';
import { LyraCardGift, PopoverImage } from './StyledLyraCardGift';

const LyraGiftLandingCard = (props) => {
  const {
    history,
    product_type,
    padding,
    isMobileWindow = false,
    voucherRemarks,
    voucherAmount,
    OnLyraVourcherRemarksChange,
    OnLyraVourcherAmountChange,
    onStoreLyraGiftCard,
    onClearError,
  } = props;
  const onHoverFullImage = <PopoverImage src={endPoints.LYRA_GIFT_CARD.URL || NoImage} alt={endPoints.LYRA_GIFT_CARD.ALT} role="presentation" />;

  const handleAddToCart = () => {
    if (!voucherRemarks || !voucherAmount) {
      onClearError(ALERT_LYRA_VOUCHER_VALUES, 'error');
      return null;
    }

    const cartItem = {
      key: `item-${Date.now()}`,
      slug: 'dynamic-gift-card',
      title: voucherRemarks,
      itemPrice: voucherAmount,
      quantity: 1,
    };

    const updatedCartList = [cartItem];

    const updatedOrderObj = {
      orderItemCount: 1,
      orderSummeryAmount: voucherAmount,
      shipping_fee_cents: 0,
      discountPersent: 0,
    };

    const lyraCartDummyObj = {
      cartList: updatedCartList,
      orderObj: updatedOrderObj,
      lyraCartItemCount: 1,
    };

    onStoreLyraGiftCard(lyraCartDummyObj);

    utils.forceRedirect(history, { pathname: constants.GIFT_CARD_CART });
    return null;
  };


  return (
    <LyraCardGift padding={padding} classRemarks={product_type === 'merchandise' ? 'h-300' : 'h-250'}>
      {isMobileWindow ?
        <img src={endPoints.LYRA_GIFT_CARD.URL || NoImage} alt={endPoints.LYRA_GIFT_CARD.ALT} role="presentation" /> :
        <Popover content={onHoverFullImage} placement="left" >
          <img src={endPoints.LYRA_GIFT_CARD.URL || NoImage} alt={endPoints.LYRA_GIFT_CARD.ALT} role="presentation" classRemarks={product_type === 'merchandise' ? 'manipal-img' : ''} />
        </Popover>}
      <div classRemarks="vourcher-Remarks">
        <Input
          onChange={({ target: { value } }) => OnLyraVourcherRemarksChange(value)}
          placeholder="Enter Remarks"
        />
      </div>
      <div className="price-button-row">
        <Input
          placeholder="Enter Amount"
          className="price-input"
          type="number"
          onChange={({ target: { value } }) => OnLyraVourcherAmountChange(Number(value))}
        />
        <Button
          type="primary"
          onClick={() => handleAddToCart()}
        >
          Add to Cart
        </Button>
      </div>
    </LyraCardGift>
  );
};

LyraGiftLandingCard.defaultProps = {
  product_type: '',
  padding: '',
  voucherRemarks: '',
  voucherAmount: 0,
};

LyraGiftLandingCard.propTypes = {
  isMobileWindow: bool.isRequired,
  product_type: string,
  padding: string,
  voucherRemarks: string,
  voucherAmount: number,
  history: shape({}).isRequired,
  OnLyraVourcherRemarksChange: func.isRequired,
  OnLyraVourcherAmountChange: func.isRequired,
  onStoreLyraGiftCard: func.isRequired,
  onClearError: func.isRequired,
};

export default LyraGiftLandingCard;



// WEBPACK FOOTER //
// client/containers/GiftCardLanding/LyraGiftLandingCard .js